import React from 'react';
import {Button, Icon} from 'semantic-ui-react';
import {FormattedMessage} from "react-intl";
import {Form, Grid, Label, Loader} from "semantic-ui-react";
import catchErrors from 'hoc/catchErrors';

/*
Key/Value Pair UI

Storing Beaker data is based on the resource API which has no concept of Maps.
This component stores key/value pairs in a single string formatted like
    key1:value1,key2:value2,...

It ain't great, but it gets the job done

*/
class KeyValuePairs extends React.Component {

    constructor(props) {
        super(props);

        // console.log('KeyValuePair')
        // console.log(props)

        this.state = {
            data: props.value
        };

        this.handleKeyChange = this.handleKeyChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleAddRowClick = this.handleAddRowClick.bind(this);
        this.triggerSave = this.triggerSave.bind(this);
        this.deleteRow = this.deleteRow.bind(this);

    }

    // given foo:1,bar:2
    // return [{key: 'foo', value:'1'}, {key: 'bar', value: '2'}]
    stringToArray(string) {
        return string ? string.split(",") //["key:value","key:value"]
                            .map(pair => {
                                return {key: pair.split(":")[0], value: pair.split(":")[1]}
                            }) //[["key","value"],["key","value"]]
                            : []
    }

    // given [{key: 'foo', value:'1'}, {key: 'bar', value: '2'}]
    // return foo:1,bar:2
    arrayToString(arr) {
        let result = arr.reduce((accumulator, currentValue, currentIndex, array) => {
            return  accumulator + ((currentIndex > 0) ? "," : "") + currentValue.key.replace(",", "") + ":" + currentValue.value
        }, "")

        // result = result.slice(0, -1)        // take off the trailing ,
        return result;
    }


    handleKeyChange(event, data) {
        // console.log("handleKeyChange")
        // console.log(event.target)

        let arr = this.stringToArray(this.state.data)
        arr[parseInt(data.position)].key = data.value
        const newValue = this.arrayToString(arr)

        this.setState({data: newValue});
        //
        // this.props.onValueChanged(newValue, false)
        // this.props.onChange(newValue, false)
    }

    handleValueChange(event, data) {
        // console.log("handleValueChange")
        // console.log(event.target)

        let arr = this.stringToArray(this.state.data)
        arr[parseInt(data.position)].value = data.value
        const newValue = this.arrayToString(arr)

        this.setState({data: newValue});
        // this.props.onValueChanged(newValue, false)
        // this.props.onChange(newValue, false)
    }

    triggerSave() {
        this.props.onChange(this.state.data)
    }

    handleAddRowClick() {
        // console.log("create name/value pair")
        if (this.state.data) {
            this.setState({data: this.state.data + ",:"});
        } else {
            this.setState({data: ":"});
        }
    }

    deleteRow(i) {
        // console.log("delete row " + i)
        let arr = this.stringToArray(this.state.data)
        arr.splice(parseInt(i), 1);

        const newValue = this.arrayToString(arr)

        this.setState({data: newValue});
        this.triggerSave()
    }

    render() {

        return (

            <div>

                <Grid columns="equal">
                    {/*
                    <Grid.Row className='db-field-label-row'>
                        <Label basic className='db-field-label'>
                            {this.props.required && <i className='icon asterisk inline required' />}
                            {this.props.label}<Loader active={this.props.loading} inline /> {this.props.loading}
                        </Label>
                    </Grid.Row>
                    */}

                {/*
                    { (this.stringToArray(this.state.data).length > 0) &&
                    <Grid.Row className="db-field-label-row">
                        <Label basic className="db-field-label">Key</Label>
                        &nbsp;
                        <Label basic className="db-field-label">Value</Label>
                    </Grid.Row>

                    }
                    */}

                    { this.stringToArray(this.state.data).map((item, i) => {

                        return (
                            <Grid.Row key={i} className="db-field-label-row">
                                <Form.Input value={item.key}
                                            key={'key'}
                                            // label={'Key'}
                                            name='key'
                                            position={i}
                                            onChange={this.handleKeyChange}
                                            onBlur={this.triggerSave}
                                            />
                                &nbsp;
                                { this.props.separator }
                                &nbsp;
                                <Form.Input value={item.value}
                                            key={'value'}
                                            // label={'Value'}
                                            name='value'
                                            position={i}
                                            onChange={this.handleValueChange}
                                            onBlur={this.triggerSave}
                                            />
                                <span onClick={() => {this.deleteRow(i)}} style={{cursor: 'pointer'}}><Icon name="delete" /></span>
                            </Grid.Row>
                        )
                    })}

                {/* <Grid.Row key={'kv-new'} className="db-field-label-row">
                        <TextInput value={this.props.value}
                                    key={'key'}
                                    label={'Key'}
                                    name='key'
                                    position={}
                                    onValueChanged={this.props.onValueChanged}/>
                        &nbsp;
                        <TextInput value={this.props.value}
                                    key={'value'}
                                    label={'Value'}
                                    name='value'
                                    onValueChanged={this.props.onValueChanged}/>
                    </Grid.Row> */}

                    <Grid.Row key={'button'} className="db-field-label-row">
                        <Button key={`createButton-NameValuePair`}
                                onClick={ this.handleAddRowClick }
                                >
                            <Icon name="plus"/> <FormattedMessage id={'create.button.keyvaluepair'}/>
                        </Button>
                    </Grid.Row>

                </Grid>



            </div>
        )
    }
};

export default catchErrors(KeyValuePairs);


// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/KeyValuePairs.jsx